"use strict";const e=require("../../node_modules/@auth0/auth0-react/dist/auth0-react.esm.js").useAuth0;module.exports=e;
//# sourceMappingURL=index.js.map
